import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'date',
})
export class DatePipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    options = { day: 'numeric', year: 'numeric', month: 'long', hour: 'numeric', minute: 'numeric' } as const;

    transform(value: string): string {
        const date = new Date(value);
        return new Intl.DateTimeFormat(`${this.translate.currentLang}-CA`, this.options).format(date);
    }
}
